"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = exports.UnreachableError = void 0;
var Error_1 = require("../Error");
exports.UnreachableError = new Error_1.MoralisCoreError({
    code: Error_1.CoreErrorCode.GENERIC_CORE_ERROR,
    message: "Incorrect type provided, code should not reach here",
});
/**
 * Typesafe check, to make sure that code never reaches a certain point.
 * Can be used as an exhaustive check in swtich/if-else statements
 *
 * When used properly with Typescript, this code should never reach, as it is typed as 'never'
 *
 * If the code does reach this assertion an UnreachableError is thrown
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var assertUnreachable = function (x) {
    throw exports.UnreachableError;
};
exports.assertUnreachable = assertUnreachable;
//# sourceMappingURL=assertUnreachable.js.map